/* eslint-disable */
export default {
  forward: '転送',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
